<dx-form #editGatewayForm
         (onFieldDataChanged)="checkEditGatewayValidation()"
         (onOptionChanged)="checkEditGatewayValidation()"
         [formData]="editedGateway"
         [labelLocation]="'top'"
         [labelMode]="'floating'">
  <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
    <span>{{ tab.title }}</span>
    <div *ngIf="!checkTabValidity(tab, editGatewayForm)" class="invalidBadge">!</div>
  </div>
  <dxi-item itemType="tabbed">
    <dxo-tab-panel-options [deferRendering]="false"
                           [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
    <dxi-tab [tabTemplate]="'titleWithValidation'"
             title="{{'REGISTRY.GATEWAY.TABS.INFORMATION' | translate}}">
      <dxi-item [editorOptions]="gatewayEditTextOptions" dataField="name">
        <dxo-label text="{{'REGISTRY.GATEWAY.NAME' | translate}}"></dxo-label>
        <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                             [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                             type="stringLength"></dxi-validation-rule>
        <dxi-validation-rule message="{{'REGISTRY.GATEWAY.VALIDATION.NAME' | translate}}"
                             type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item [editorOptions]="{
                  dataSource: gatewayTypes,
                  displayExpr: 'modelName',
                  valueExpr: 'id',
                  disabled: !this.isEditMode
                }" dataField="type.id"
                editorType="dxSelectBox"
      >
        <dxo-label text="{{'REGISTRY.GATEWAY.TYPE' | translate}}"></dxo-label>
        <dxi-validation-rule message="{{'REGISTRY.GATEWAY.VALIDATION.TYPE' | translate}}"
                             type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item [editorOptions]="{disabled: true}" dataField="macAddress">
        <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                             [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                             type="stringLength"></dxi-validation-rule>
        <dxo-label text="{{'REGISTRY.GATEWAY.MACADDRESS' | translate}}"></dxo-label>
      </dxi-item>

      <dxi-item [editorOptions]="{
                    dataSource: sendingCronFrequencyValues,
                    displayExpr: getAcquisitionCronLabel,
                    disabled: !this.isEditMode
                  }" dataField="sendingCron"
                editorType="dxSelectBox"
      >
        <dxo-label text="{{'REGISTRY.GATEWAY.SENDING_FREQUENCY' | translate}}"></dxo-label>
        <dxi-validation-rule message="{{'REGISTRY.GATEWAY.VALIDATION.SENDING_FREQUENCY' | translate}}"
                             type="required"></dxi-validation-rule>
      </dxi-item>

      <dxi-item [editorOptions]="{disabled: true}">
        <dxo-label text="{{'REGISTRY.GATEWAY.NETCONFIG' | translate}}"></dxo-label>
        <dx-data-grid
          *ngIf="!!editedGateway"
          [columnAutoWidth]="true"
          [dataSource]="this.selectedGatewayNetConfig!"
          [showBorders]="true"
          [showRowLines]="false"
          [wordWrapEnabled]="true"
          height="100%"
          id="netConfigDataGrid"
          keyExpr="name"
        >

          <dxo-toolbar>
            <dxi-item location="before">
              <p
                style="font-size:18px; margin: 0 0 0 10px;">{{ 'REGISTRY.GATEWAY.TABLES.NETCONFIG' | translate }}</p>
            </dxi-item>
          </dxo-toolbar>

          <dxo-paging
            [enabled]="false">
          </dxo-paging>

          <dxo-scrolling
            mode="standard">
          </dxo-scrolling>

          <dxo-selection mode="single"></dxo-selection>
          <dxi-column caption="{{'REGISTRY.GATEWAY.NETCONFIG_FIELDS.NAME' | translate}}"
                      dataField="name"></dxi-column>
          <dxi-column [width]="75"
                      caption="{{'REGISTRY.GATEWAY.NETCONFIG_FIELDS.ENABLED' | translate}}"
                      dataField="enabled"></dxi-column>
          <dxi-column caption="{{'REGISTRY.GATEWAY.NETCONFIG_FIELDS.MACADDRESS' | translate}}"
                      cellTemplate="netConfigTemplate"
                      dataField="macAddress"></dxi-column>
          <dxi-column caption="{{'REGISTRY.GATEWAY.NETCONFIG_FIELDS.GATEWAY' | translate}}"
                      dataField="gateway"></dxi-column>
          <dxi-column caption="{{'REGISTRY.GATEWAY.NETCONFIG_FIELDS.DNS' | translate}}"
                      dataField="dns"></dxi-column>
          <dxi-column [width]="75" caption="{{'REGISTRY.GATEWAY.NETCONFIG_FIELDS.DHCP' | translate}}"
                      dataField="dhcp"></dxi-column>

          <div *dxTemplate="let data of 'netConfigTemplate'">
            <div> {{ data.data.macAddress }}<br>
              {{ data.data.ip }}<br>
              {{ data.data.netmask }}
            </div>
          </div>

        </dx-data-grid>
      </dxi-item>
    </dxi-tab>
  </dxi-item>


</dx-form>
